import gql from "graphql-tag.macro";

// v3ProjectId: arg({ type: "ID" }),
// v2DocumentId: arg({ type: "ID" }),
// v2HeadingId: arg({ type: "ID" }),
// headingOwnerId: arg({ type: "ID" }),
//query current user
const loadCurrentUserQuery = gql`
  query me{
    me(forceRefresh: true){
        _id
        username
        firstname
        lastname
        groups {
          name
        }
    }
  }
`;
const saveHeadingWorkflowMutation = gql`
    mutation updateHeadingWorkflow($v3ProjectId: ID!, $v2DocumentId: ID!, $v2HeadingId: ID!, $headingOwnerId: ID) {
        updateHeadingWorkflow(v3ProjectId: $v3ProjectId, v2DocumentId: $v2DocumentId, v2HeadingId: $v2HeadingId, headingOwnerId: $headingOwnerId) {
            _id
            name
            headingOwnerId
            headingOwner {
                _id
                email
                firstname
                lastname
            }
        }
    }
`;

const loadHeadingWorkflowQuery = gql`
    query loadHeadingWorkflow($v3ProjectId: ID!, $v2DocumentId: ID!, $v2HeadingId: ID!) {
        headingWorkflowInstance(v3ProjectId: $v3ProjectId, v2DocumentId: $v2DocumentId, v2HeadingId: $v2HeadingId) {
            _id
            headingOwner {
                _id
                email
                firstname
                lastname
            }
        }
    }
`;

export const loadCurrentUser = async (_,{ client })=>{
    const { data:{ me:data } } =await client.query({
        query: loadCurrentUserQuery,
        variables: {  },
        fetchPolicy: "no-cache",
    });
    return data;
};

export const saveHeadingWorkflow = async (params, { client }) => {
    const { v3ProjectId, v2DocumentId, v2HeadingId, headingOwnerId } = params;
    const { data: { updateHeadingWorkflow } = {} } = await client.mutate({
        mutation: saveHeadingWorkflowMutation,
        // eslint-disable-next-line no-underscore-dangle
        variables: { v3ProjectId, v2DocumentId, v2HeadingId, headingOwnerId },
    });
    return updateHeadingWorkflow;
};

export const getSubHeadingIDs = async ({ parentHeadingId }) => {
    return [];
};

export const loadHeadingWorkflow = async ({ v3ProjectId, v2DocumentId, v2HeadingId }, { client }) => {
    const {
        data: { headingWorkflowInstance: data },
    } = await client.query({
        query: loadHeadingWorkflowQuery,
        variables: { v3ProjectId, v2DocumentId, v2HeadingId },
        fetchPolicy: "no-cache",
    });
    return data;
};

export const v2ReadHeading = async ({ headingId }) => {
    // check if we are in v2 & get v2 doc if possible
    if (window?.APPVERSION?.directory && headingId) {
        try {
            const { object } = await new Promise((reso, rej) => {
                window.app.Duchess.readObject(
                    "Heading",
                    {
                        ID: headingId,
                    },
                    res => {
                        return res.success ? reso(res) : rej(res);
                    }
                );
            });
            const childHeadings = object?.childHeadings || [];
            let result = object?.childHeadings || [];
            for (let i = 0; i <= childHeadings.length - 1; i++) {
                result = result.concat(await v2ReadHeading({ headingId: childHeadings[i] }));
            }
            return result;
        } catch (e) {
            console.error(e);
            return [];
        }
    }

    // Not in v2 - just return v3 data
    return [];
};

export const closeV2HeadingDialog = async () => {
    if (window?.APPVERSION?.directory) {
        try {
            window?.app?.Modules?.Heading?.closeDialog?.();
        } catch (e) {
            console.error(e);
            return;
        }
    }
    // Not in v2 - just return v3 data
    return;
};
